import gql from 'graphql-tag';

export default gql`
  fragment salesforceDealRecordTypeFragment on SalesforceDealRecordType {
    id
    name
    recordTypeId
  }
`;
